<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs>
        <v-layout
          row
          wrap
          justify-center
          align-center
          pa-0
          pt-3
          v-for="(item, index) in ItemConsent"
          :key="index"
        >
          <v-flex xs11 sm11 md9 lg9 pa-2>
            <v-card class="rounded-lg">
              <v-card-title class="pa-3">
                <b>ประกาศ</b>
                <div class="ml-2">{{ item.AnnounceNo }}</div>
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  dark
                  color="#077893"
                  @click="Fn_ViewDetail(item)"
                  class="mr-2"
                >
                  ดูรายละเอียด</v-btn
                >
              </v-card-title>
              <hr class="new4" />
              <!-- <v-progress-linear
                x-small
                color="green lighten-3"
                value="100"
              ></v-progress-linear> -->
              <v-card-text class="pa-4">
                <p><b>เรื่อง</b> : {{ item.AnnounceName }} ​</p>

                <p><b>วันที่ประกาศ</b> : {{ item.SendAt }} ​</p>
                <p>
                  <b>สถานะ</b> :
                  <b v-if="item.SendStatus === 'OK'">
                    <v-chip
                      class="ma-2"
                      color="green lighten-4"
                      text-color="green"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      รับทราบประกาศรายการเรียบร้อยแล้ว
                    </v-chip>
                  </b>
                  <b v-else-if="item.SendStatus === 'WAIT'">
                    <v-chip
                      class="ma-2"
                      color="orange lighten-4"
                      text-color="orange"
                    >
                      <v-icon left>mdi-alert-circle-outline</v-icon>
                      {{ $t("dashboard.statuspen") }}
                    </v-chip>
                  </b>
                  <b v-else-if="item.SendStatus === 'Read'">
                    <v-chip
                      class="ma-2"
                      color="indigo lighten-4"
                      text-color="indigo"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      อ่านแล้ว
                    </v-chip>
                  </b>
                  <b v-else-if="item.SendStatus === 'Error'">
                    <v-chip class="ma-2" color="red lighten-4" text-color="red">
                      <v-icon>mdi-close-circle-outline</v-icon>
                      ส่งไม่สำเร็จ
                    </v-chip></b
                  >
                </p>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <br /><br />
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      Page: 1,
      ItemPerPage: 10,
      ItemConsent: [],
      ItemCount: [],
      number: [],
      AccessToken: "",
      AccountId: "",
      DialogDelete: false,
      loadingDownloadData: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _PathType: {
      get() {
        return this.$route.path.split("/")[2] || "-";
      },
    },
  },
  mounted() {
    this.$cookies.remove("ChatAccessToken");
    this.$cookies.remove("ChatAccountId");
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[3],
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/Redirect",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.AccessToken;
            this.AccountId = response.data.Message.AccountId;
            this.$cookies.set(
              "ChatAccessToken",
              response.data.Message.AccessToken
            );
            this.$cookies.set("ChatAccountId", response.data.Message.AccountId);
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        AccountId: this.AccountId,
        AccessToken: this.AccessToken,
      };
      var Headers = {
        AccountId: this.$cookies.get("ChatAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/HistoryAnnounce",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemConsent.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemConsent) {
              this.ItemConsent[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ViewDetail(href) {
      this.$store.dispatch("SET_DATA_CONSENT_ONECHAT", href);
      this.$store.dispatch("SET_DATA_CONSENT_ONECHAT_PATH", this.$route.path);
      this.$router.push("/onechat-announce-history-detail");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

hr.new4 {
  border: 1px solid #077893;
}
</style>
